const getFill = shape => (shape.getIn(['fill', 'type']) === 'imageSource' ?
    shape.updateIn(['fill', 'imageSource'], imageSource => imageSource.split('/').pop()).get('fill').toJS() :
    shape.get('fill').toJS());

export default getFill;
